export default __webpack_public_path__ + "static/media/IncredibleAnimalsPredators_06.e3cc424c.png";